import axios from "axios";
export const COUNTRY = "countries";
export const ADD_COUNTRY = "country";
export const DELETE = "container/delete/master-container";
export const CONTAINER_FRANCHISE = "franchise-container/container-listing"
export const  CONTAINER_LIST = "container/container"

export function deleteContainerM(data) {
  return axios.post(import.meta.env.REACT_APP_SITE_URL + DELETE, data);
}
//api for active country
export function findActiveCountry() {
  return axios.get(import.meta.env.REACT_APP_SITE_URL + COUNTRY);
}

//api for all type of country (active or deactive)
/**
 * Fetch a page of containers across all franchises, for the Settings list.
 *
 * @param {Object} queryParams pageNumber, pageSize, sortField, sortOrder and filter.search
 * @returns {Promise}
 */
export function findCountryList(queryParams) {
  return axios.get(
    import.meta.env.REACT_APP_SITE_URL +
      ADD_COUNTRY +
      `?page=${queryParams.pageNumber}&per_page=${queryParams.pageSize}&sort_by=${queryParams.sortField}&sort_dir=${queryParams.sortOrder}&search_keyword=${queryParams.filter.search}`
  );
}
/**
 * Fetch a page of a franchise's containers, filtered and optionally sorted.
 *
 * @param {Object} queryParams pageNumber, pageSize, franchise_id, the search
 *   fields, and optional sort_by / sort_dir (omitted = newest first)
 * @returns {Promise}
 */
export function getContainerFranchise(queryParams) {
  let url =
    import.meta.env.REACT_APP_SITE_URL +
    CONTAINER_FRANCHISE +
    `?page=${queryParams.pageNumber}&per_page=${queryParams.pageSize}&franchise_id=${queryParams.franchise_id}`;
  if (queryParams.reference_unique_id) {
    url += `&reference_unique_id=${encodeURIComponent(queryParams.reference_unique_id.trim())}`;
  }
  if (queryParams.container_room_number) {
    url += `&container_room_number=${encodeURIComponent(queryParams.container_room_number.trim())}`;
  }
  if (queryParams.container_serial_number) {
    url += `&container_serial_number=${encodeURIComponent(queryParams.container_serial_number.trim())}`;
  }
  if (queryParams.sort_by) {
    url += `&sort_by=${encodeURIComponent(queryParams.sort_by)}&sort_dir=${queryParams.sort_dir === "desc" ? "desc" : "asc"}`;
  }
  return axios.get(url);
}
export function containerList(queryParams) {
  return axios.get(
    `${import.meta.env.REACT_APP_SITE_URL + CONTAINER_LIST}?page=${
      queryParams.pageNumber
    }&per_page=${queryParams.pageSize}&sort_by=${
      queryParams.sortField
    }&sort_dir=${queryParams.sortOrder}`
  );
}

export function createContainer(data , edit) {
  return axios.post(import.meta.env.REACT_APP_SITE_URL + CONTAINER_LIST+ edit, data);
}